// Front end javascript file
// you might want to have everything within one of these bad boys:
// window.addEventListener('load', (event) => { --> code here <-- });
// Or if you don't want to wait for images and other resources to load
//addEventListener("DOMContentLoaded", (event) => { --> code here <--  });